import React from "react";
import TitleTextLayout from "../components/Base/TitleTextLayout";
import { Box, Container, Grid, useMediaQuery } from "@mui/material";
import { VERTICAL_SPACE, baseGrey } from "../graphic/theme";
import uvodImg from "../graphic/Images/uvod-b.png";
import uvodOrange from "../graphic/Images/uvod-a.png";
import uvodImgwebp from "../graphic/Images/uvod-b.webp";
import uvodOrangewebp from "../graphic/Images/uvod-a.webp";
import { theme } from "../../App";

export default function TitleLayout() {
  let _900to1050 = useMediaQuery(theme.breakpoints.between("900", "1050"));
  let _0to750 = useMediaQuery(theme.breakpoints.between("0", "750"));
  let _0to390 = useMediaQuery(theme.breakpoints.between("0", "390"));

  let mobile = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <div style={{}}>
      <Container
        maxWidth="lg"
        sx={{
          bgcolor: baseGrey,
          pl: "0px !important",
          position: "relative",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <Grid
          container
          spacing={2}
          columns={24}
          sx={{
            px: VERTICAL_SPACE,
            pt: { xs: "60px", sm: "40px", md: "120px" },
            pb: { xs: "410px", sm: _0to750 ? "490px" : "475px", md: "120px" },
          }}
        >
          <Grid item xs={24} sm={24} md={24} lg={24} sx={{ zIndex: "90" }}>
            <TitleTextLayout
              title="Zajišťujeme přepravu materiálu v okolí Brna"
              text="Doprava | Kontejnery | Ukládka"
              buttonText={"Zaslat poptávku"}
              onButtonClick={() => {
                if (window && document) {
                  window.scrollTo({
                    top: document.body.scrollHeight - 980,
                    left: 0,
                    behavior: "smooth",
                  });
                }
              }}
            />
          </Grid>
          <Box
            sx={{
              position: "absolute",
              top: _0to390
                ? "auto"
                : { xs: 430, sm: _0to750 ? 430 : 270, md: 0 },
              bottom: _0to390 ? -10 : "auto",
              right: _900to1050
                ? -250
                : _0to390
                ? -100
                : _0to750
                ? 0
                : { sm: -200, md: -200, lg: -120 },
              zIndex: "70",
            }}
          >
            <picture>
              <source srcSet={uvodImgwebp} type="image/webp" />
              <Box
                component="img"
                alt="Uvod"
                src={uvodImg}
                sx={{
                  height: { xs: "320px", sm: _0to750 ? "400px" : "542px" },
                  width: "auto",
                }}
              />
            </picture>
          </Box>
          {!mobile && (
            <Box
              sx={{
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: "60",
              }}
            >
              <picture>
                <source srcSet={uvodOrangewebp} type="image/webp" />
                <Box
                  component="img"
                  alt="Uvod"
                  src={uvodOrange}
                  sx={{ height: "370px", width: "auto" }}
                />
              </picture>
            </Box>
          )}
        </Grid>
      </Container>
    </div>
  );
}
